export default {
  pageNotFound_error: '{{log.user.name}} tried to access a non-existent page',

  mutationUpsertUser: '{{log.user.name}} saved user: {{log.entity.name}}',

  createUser: '{{log.user.name}} created user: {{log.entity.name}}',
  updateUser: '{{log.user.name}} updated user: {{log.entity.name}}',
  createUser_error: '{{log.user.name}} received an error when registering user: {{log.entity.name}}',
  updateUser_error: '{{log.user.name}} received an error when updating user: {{log.entity.name}}',
  removeUsers: '{{log.user.name}} removed some users',
  mutationRemoveUsers: '{{log.user.name}} removed some users',
  mutationRemoveUsers_error: '{{log.user.name}} received an error when removing some users',
  removeUsers_error: '{{log.user.name}} received an error when removing some users',

  mutationUpsertTrigger: '{{log.user.name}} saved a trigger',
  mutationRemoveTriggers: '{{log.user.name}} removed some triggers',
  mutationRemoveTriggers_error: '{{log.user.name}} received an error when removing some triggers',

  createChecklist: '{{log.user.name}} created checklist: {{log.entity.name}}',
  updateChecklist: '{{log.user.name}} updated checklist: {{log.entity.name}}',
  createChecklist_error: '{{log.user.name}} received an error when saving checklist: {{log.entity.name}}',
  updateChecklist_error: '{{log.user.name}} received an error when saving checklist: {{log.entity.name}}',
  removeChecklists: '{{log.user.name}} removed some checklists',
  removeChecklists_error: '{{log.user.name}} received an error when removing some checklists',

  createServiceOrder: '{{log.user.name}} created activity: {{log.entity.name}}',
  updateServiceOrder: '{{log.user.name}} updated activity: {{log.entity.name}}',
  mutationUpsertServiceOrder: '{{log.user.name}} saved activity: {{log.entity.name}}',
  createServiceOrder_error: '{{log.user.name}} received an error when saving activity: {{log.entity.name}}',
  updateServiceOrder_error: '{{log.user.name}} received an error when saving activity: {{log.entity.name}}',
  removeServiceOrders: '{{log.user.name}} removed some activities',
  removeServiceOrders_error: '{{log.user.name}} received an error when removing some activities',
  saveServiceOrderReplies: '{{log.user.name}} changed activity replies: {{log.entity.name}}',
  saveServiceOrderReplies_error:
    '{{log.user.name}} received an error when changing activity replies: {{log.entity.name}}',

  createActionPlan: '{{log.user.name}} created an action plan',
  createActionPlan_error: '{{log.user.name}} received an error when creating an action plan',

  updateServiceOrderStatus_execution: '{{log.user.name}} updated activity status to execution',
  updateServiceOrderStatus_execution_error:
    '{{log.user.name}} received an error when updating activity status to execution',
  updateServiceOrderStatus_pause: '{{log.user.name}} updated activity status to paused',
  updateServiceOrderStatus_pause_error: '{{log.user.name}} received an error when updating activity status to paused',
  updateServiceOrderStatus_completed: '{{log.user.name}} updated activity status to completed',
  updateServiceOrderStatus_completed_error:
    '{{log.user.name}} received an error when updating activity status to completed',
  updateServiceOrderStatus_approved: '{{log.user.name}} updated activity status to approved',
  updateServiceOrderStatus_approved_error:
    '{{log.user.name}} received an error when updating activity status to approved',
  updateServiceOrderStatus_disapproved: '{{log.user.name}} updated activity status to disapproved',
  updateServiceOrderStatus_disapproved_error:
    '{{log.user.name}} received an error when updating activity status to disapproved',
  updateServiceOrderStatus_canceled: '{{log.user.name}} updated activity status to canceled',
  updateServiceOrderStatus_canceled_error:
    '{{log.user.name}} received an error when updating activity status to canceled',

  savePlace: '{{log.user.name}} saved a place/person',
  savePlace_plural: '{{log.user.name}} saved {{count}} places/people',
  savePlace_error: '{{log.user.name}} received an error when saving places/people',
  removePlaces: '{{log.user.name}} removed some places/people',
  removePlaces_error: '{{log.user.name}} received an error when removing some places/people',

  createBucket: '{{log.user.name}} created qrcode batch: {{log.entity.name}}',
  updateBucket: '{{log.user.name}} updated qrcode batch: {{log.entity.name}}',
  createBucket_error: '{{log.user.name}} received an error when saving qrcode batch: {{log.entity.name}}',
  updateBucket_error: '{{log.user.name}} received an error when saving qrcode batch: {{log.entity.name}}',
  removeBuckets: '{{log.user.name}} removed some qrcode batches',
  removeBuckets_error: '{{log.user.name}} received an error when removing some qrcode batches',

  createSegment: '{{log.user.name}} created segmentation: {{log.entity.name}}',
  updateSegment: '{{log.user.name}} updated segmentation: {{log.entity.name}}',
  createSegment_error: '{{log.user.name}} received an error when saving segmentation: {{log.entity.name}}',
  updateSegment_error: '{{log.user.name}} received an error when saving segmentation: {{log.entity.name}}',
  removeSegments: '{{log.user.name}} removed some segmentations',
  removeSegments_error: '{{log.user.name}} received an error when removing some segmentations',

  createForm: '{{log.user.name}} created form: {{log.entity.name}}',
  updateForm: '{{log.user.name}} updated form: {{log.entity.name}}',
  createForm_error: '{{log.user.name}} received an error when creating form: {{log.entity.name}}',
  updateForm_error: '{{log.user.name}} received an error when updating form: {{log.entity.name}}',
  removeForm: '{{log.user.name}} removed some forms',
  removeForm_error: '{{log.user.name}} received an error when removing some forms',
  answerForm: 'A new form reply: {{log.entity.name}} was received',
  answerForm_error: 'An error occurred when replying to form: {{log.entity.name}}',

  enableModule: '{{log.user.name}} enabled module: {{log.entities.0.name}} | {{log.entities.1.name}}',
  disableModule: '{{log.user.name}} disabled module: {{log.entities.0.name}} | {{log.entities.1.name}}',
  updateModule: '{{log.user.name}} updated module: {{log.entities.0.name}} | {{log.entities.1.name}}',
  enableModule_error:
    '{{log.user.name}} received an error when enabling module: {{log.entities.0.name}} | {{log.entities.1.name}}',
  disableModule_error:
    '{{log.user.name}} received an error when disabling module: {{log.entities.0.name}} | {{log.entities.1.name}}',
  updateModule_error:
    '{{log.user.name}} received an error when updating module: {{log.entities.0.name}} | {{log.entities.1.name}}',

  importUser: '{{log.user.name}} requested a user import',
  importRefund: '{{log.user.name}} requested a refund import',
  importPlace: '{{log.user.name}} requested a place/person import',
  importForm: '{{log.user.name}} requested a form import',
  importChecklist: '{{log.user.name}} requested a checklist import',
  importServiceOrder: '{{log.user.name}} requested an activity import',

  exportUsers: '{{log.user.name}} requested a user export',
  exportUser: '$t(exportUser)',
  exportRefunds: '{{log.user.name}} requested a refund export',
  exportRefund: '$t(exportRefunds)',
  exportPlaces: '{{log.user.name}} requested a place/person export',
  exportPlace: '$t(exportPlaces)',
  exportForm: '{{log.user.name}} requested a form export',
  exportChecklists: '{{log.user.name}} requested a checklist export',
  exportChecklist: '$t(exportChecklists)',
  exportServiceOrders: '{{log.user.name}} requested an activity export',
  exportServiceOrder: '$t(exportServiceOrders)',

  login: '{{log.user.name}} logged in on {{log.origin}}',
  login_error: 'Email: {{log.entity.name}} failed to log in on {{log.origin}}',
  logout: '{{log.user.name}} logged out on {{log.origin}}',
  forceLogout_warn: '{{log.user.name}} was forced to log out on {{log.origin}}',
  access: '{{log.user.name}} accessed on {{log.origin}}',

  addLog_warn: '{{log.user.name}} tried to save a log but failed',
  apiCall_error:
    '{{log.user.name}} received an error when calling api: {{log.data.payload.method}} /{{log.data.payload.path}}',

  monitorApiCall: `{{log.user.name}} called api: {{log.data.payload.method}} /{{log.data.payload.path}}`,

  initSync: '{{log.user.name}} started a sync',
  endSync: '{{log.user.name}} finished a sync',

  fetchSyncSegment: '{{log.user.name}} received {{log.data.response.result.rowsLength}} segmentations via sync',
  fetchSyncChecklist: '{{log.user.name}} received {{log.data.response.result.rowsLength}} checklists via sync',
  fetchSyncPlace: '{{log.user.name}} received {{log.data.response.result.rowsLength}} places/people via sync',
  fetchSyncUser: '{{log.user.name}} received {{log.data.response.result.rowsLength}} users via sync',
  fetchSyncStatus: '{{log.user.name}} received {{log.data.response.result.rowsLength}} statuses via sync',
  fetchSyncCompany: '{{log.user.name}} received {{log.data.response.result.rowsLength}} companies via sync',
  fetchSyncPlaceLevel: '{{log.user.name}} received {{log.data.response.result.rowsLength}} place levels via sync',
  fetchSyncField:
    '{{log.user.name}} received {{log.data.response.result.rowsLength}} additional field configurations via sync',
  fetchSyncServiceOrder: '{{log.user.name}} received {{log.data.response.result.rowsLength}} activities via sync',
  fetchSyncLevel:
    '{{log.user.name}} received {{log.data.response.result.rowsLength}} place level configuration via sync',
  requestSyncServiceOrder: '{{log.user.name}} sent an activity via sync',
  requestSyncReply: '{{log.user.name}} sent activity replies via sync',
  requestSyncEvent: '{{log.user.name}} sent activity events via sync',
  clearDB_warn: '{{log.user.name}} deleted all mobile app data',
  clearSyncPending_warn: '{{log.user.name}} forced to remove all sync pending items',

  saved: 'saved',
  stacktrace: 'Stacktrace'
}
